module.exports = __webpack_public_path__ + "static/img/india-flag.0d62a101.svg";